import { Link } from "react-router-dom";

interface Crumb {
  label: string;
  to?: string;
}

interface BreadcrumbProps {
  items: Crumb[];
}

export default function Breadcrumb({ items }: BreadcrumbProps) {
  return (
    <nav aria-label="面包屑导航" className="mb-4">
      <ol className="flex flex-wrap items-center gap-x-2 gap-y-1 text-xs text-foreground-500">
        <li>
          <Link to="/" className="flex items-center gap-1 transition-colors hover:text-accent-400">
            <i className="ri-home-4-line text-sm" />
            首页
          </Link>
        </li>
        {items.map((item, index) => (
          <li key={`${item.label}-${index}`} className="flex items-center gap-2">
            <i className="ri-arrow-right-s-line text-sm text-foreground-700" />
            {item.to ? (
              <Link to={item.to} className="transition-colors hover:text-accent-400">
                {item.label}
              </Link>
            ) : (
              <span className="text-foreground-200" aria-current="page">
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
}